<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <timesheets-page />
    </div>
  </div>
</template>

<script>
import TimesheetsPage from '../Components/TimesheetsPage.vue';

export default {
  name: 'Timesheets',
  components: {
    'timesheets-page': TimesheetsPage,
  },
};
</script>

<style scoped></style>
